module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/timesheet/timesheetUpload/JobStatus.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        ';
 if (model.get('state') === 'pending') { 
__p+='\n            <h5>File uploaded. Process about to start...</h5>\n        ';
 } else if (model.get('state') === 'processing') { 
__p+='\n            <h5>Creating timesheets...</h5>\n        ';
 } else { 
__p+='\n            <h5>Bulk upload complete.</h5>\n        ';
 } 
__p+='\n    </div>\n    <div class="ibox-content tab-content">\n        ';
 if (model.get('state') !== 'done') { 
__p+='\n            <div>\n                <i class="fa fa-clock-o"></i>\n                <label>Awaiting results...</label>\n            </div>\n        ';
 } else { 
__p+='\n            ';
 if (model.get('itemCount')) { 
__p+='\n                <div>\n                    <i class="fa fa-check green" aria-hidden="true"></i>\n                    <label>\n                        Successfully created time entries for\n                        '+
((__t=( model.get('itemCount') ))==null?'':_.escape(__t))+
' employees.\n                    </label>\n                </div>\n            ';
 } else { 
__p+='\n                <div>\n                    <i class="fa fa-times red" aria-hidden="true"></i>\n                    <label>\n                        No data imported.\n                    </label>\n                </div>\n            ';
 } 
__p+='\n\n            ';
 if (model.get('itemCount') && model.get('uploadErrors').length) { 
__p+='\n                <hr/>\n            ';
 } 
__p+='\n\n            ';
 if (model.get('uploadErrors').length) { 
__p+='\n                <div>\n                    <label>\n                        There were some errors when trying to import timesheets:\n                    </label>\n                </div>\n                <div>\n                    ';
 model.get('uploadErrors').forEach(function (e) { 
__p+='\n                        <div>\n                            <i class="fa fa-times red" aria-hidden="true"></i>\n                            <span>'+
((__t=( e.name ))==null?'':_.escape(__t))+
'</span>\n                            <ul>\n                                ';
 e.errors.forEach(function (error) { 
__p+='\n                                    <li>'+
((__t=( error ))==null?'':_.escape(__t))+
'</li>\n                                ';
 }); 
__p+='\n                            </ul>\n                        </div>\n                    ';
 }); 
__p+='\n                </div>\n            ';
 } 
__p+='\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/timesheet/timesheetUpload/JobStatus.ejs
// module id = 1034
// module chunks = 1